var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filter-builder" }, [
    !_vm.localConditions.filterGroups ||
    _vm.localConditions.filterGroups.length === 0
      ? _c(
          "div",
          { staticClass: "empty-filters" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.$t("contactModuleRules.filterBuilder.noConditions"))
              ),
            ]),
            _vm._v(" "),
            _c(
              "a-button",
              { attrs: { type: "primary" }, on: { click: _vm.addFilterGroup } },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t(
                        "contactModuleRules.filterBuilder.addFirstCondition"
                      )
                    ) +
                    "\n        "
                ),
              ]
            ),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "filter-body" },
          [
            _vm._l(
              _vm.localConditions.filterGroups,
              function (group, groupIndex) {
                return _c(
                  "div",
                  {
                    key: "group-" + groupIndex,
                    staticClass: "filter-group-container",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _vm.localConditions.filterGroups.length > 1
                          ? _c(
                              "div",
                              { staticClass: "group-header" },
                              [
                                _c("span", { staticClass: "group-title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "contactModuleRules.filterBuilder.groupTitle",
                                        { n: groupIndex + 1 }
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      icon: "delete",
                                      size: "small",
                                      danger: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeGroup(groupIndex)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$t(
                                            "contactModuleRules.filterBuilder.deleteGroup"
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(group.filters, function (filter, filterIndex) {
                          return _c(
                            "div",
                            {
                              key: "filter-" + filterIndex,
                              staticClass: "filter-row",
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "filter-text" },
                                [
                                  filterIndex === 0
                                    ? _c("span", { staticClass: "prefix" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "contactModuleRules.filterBuilder.if"
                                            )
                                          )
                                        ),
                                      ])
                                    : _c("InlineSelectOperator", {
                                        staticClass: "prefix-operator",
                                        attrs: {
                                          options: [
                                            {
                                              label: _vm.$t(
                                                "contactModuleRules.filterBuilder.andOption"
                                              ),
                                              value: "AND",
                                            },
                                            {
                                              label: _vm.$t(
                                                "contactModuleRules.filterBuilder.orOption"
                                              ),
                                              value: "OR",
                                            },
                                          ],
                                        },
                                        on: { change: _vm.emitChange },
                                        model: {
                                          value: group.operator,
                                          callback: function ($$v) {
                                            _vm.$set(group, "operator", $$v)
                                          },
                                          expression: "group.operator",
                                        },
                                      }),
                                  _vm._v(" "),
                                  _c("InlineSelect", {
                                    attrs: {
                                      options: _vm.getAvailableFields(),
                                      placeholder: _vm.$t(
                                        "contactModuleRules.filterBuilder.selectField"
                                      ),
                                      searchable: true,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onFieldChange(filter)
                                      },
                                    },
                                    model: {
                                      value: filter.field,
                                      callback: function ($$v) {
                                        _vm.$set(filter, "field", $$v)
                                      },
                                      expression: "filter.field",
                                    },
                                  }),
                                  _vm._v(" "),
                                  filter.field
                                    ? _c("InlineSelectOperator", {
                                        attrs: {
                                          options: _vm.getOperatorsForField(
                                            filter.field
                                          ),
                                          placeholder: _vm.$t(
                                            "contactModuleRules.filterBuilder.operator"
                                          ),
                                        },
                                        on: { change: _vm.emitChange },
                                        model: {
                                          value: filter.operator,
                                          callback: function ($$v) {
                                            _vm.$set(filter, "operator", $$v)
                                          },
                                          expression: "filter.operator",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  filter.field &&
                                  filter.operator &&
                                  _vm.needsValue(filter.operator)
                                    ? [
                                        _vm.isMultiSelect(filter)
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "multi-value-wrapper",
                                              },
                                              [
                                                _c(
                                                  "a-select",
                                                  {
                                                    staticClass:
                                                      "multi-select-inline",
                                                    attrs: {
                                                      mode: "multiple",
                                                      placeholder: _vm.$t(
                                                        "contactModuleRules.filterBuilder.select"
                                                      ),
                                                    },
                                                    on: {
                                                      change: _vm.emitChange,
                                                    },
                                                    model: {
                                                      value: filter.value,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          filter,
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filter.value",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.getFieldOptions(
                                                      filter.field
                                                    ),
                                                    function (opt) {
                                                      return _c(
                                                        "a-select-option",
                                                        {
                                                          key: opt.value,
                                                          attrs: {
                                                            value: opt.value,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                        " +
                                                              _vm._s(
                                                                opt.label
                                                              ) +
                                                              "\n                                    "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm.hasOptions(filter.field)
                                          ? _c("InlineSelectValue", {
                                              attrs: {
                                                options: _vm.getFieldOptions(
                                                  filter.field
                                                ),
                                                placeholder: _vm.$t(
                                                  "contactModuleRules.filterBuilder.selectValue"
                                                ),
                                                searchable: true,
                                              },
                                              on: { change: _vm.emitChange },
                                              model: {
                                                value: filter.value,
                                                callback: function ($$v) {
                                                  _vm.$set(filter, "value", $$v)
                                                },
                                                expression: "filter.value",
                                              },
                                            })
                                          : _vm.getFieldDataType(
                                              filter.field
                                            ) === "boolean"
                                          ? _c("InlineSelectValue", {
                                              attrs: {
                                                options: [
                                                  {
                                                    label: "Evet",
                                                    value: true,
                                                  },
                                                  {
                                                    label: "Hayır",
                                                    value: false,
                                                  },
                                                ],
                                                placeholder: _vm.$t(
                                                  "contactModuleRules.filterBuilder.select"
                                                ),
                                              },
                                              on: { change: _vm.emitChange },
                                              model: {
                                                value: filter.value,
                                                callback: function ($$v) {
                                                  _vm.$set(filter, "value", $$v)
                                                },
                                                expression: "filter.value",
                                              },
                                            })
                                          : _c("InlineInput", {
                                              attrs: {
                                                type:
                                                  _vm.getFieldDataType(
                                                    filter.field
                                                  ) === "number"
                                                    ? "number"
                                                    : "text",
                                                placeholder: _vm.$t(
                                                  "contactModuleRules.filterBuilder.enterValue"
                                                ),
                                              },
                                              on: { change: _vm.emitChange },
                                              model: {
                                                value: filter.value,
                                                callback: function ($$v) {
                                                  _vm.$set(filter, "value", $$v)
                                                },
                                                expression: "filter.value",
                                              },
                                            }),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  staticClass: "remove-btn",
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeFilter(
                                        groupIndex,
                                        filterIndex
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("delete_outline"),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "add-condition-btn",
                            on: {
                              click: function ($event) {
                                return _vm.addFilterToGroup(groupIndex)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("add"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "contactModuleRules.filterBuilder.addCondition"
                                  )
                                )
                              ),
                            ]),
                          ]
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    groupIndex < _vm.localConditions.filterGroups.length - 1
                      ? _c("div", { staticClass: "group-operator-row" }, [
                          _c("div", { staticClass: "separator-line" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "operator-badge" },
                            [
                              _c(
                                "a-select",
                                {
                                  staticClass: "operator-selector",
                                  attrs: { size: "small" },
                                  on: { change: _vm.emitChange },
                                  model: {
                                    value: _vm.localConditions.groupOperator,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.localConditions,
                                        "groupOperator",
                                        $$v
                                      )
                                    },
                                    expression: "localConditions.groupOperator",
                                  },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "AND" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("contactModuleRules.AND")
                                        ) + " (AND)"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "OR" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("contactModuleRules.OR")
                                        ) + " (OR)"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "separator-line" }),
                        ])
                      : _vm._e(),
                  ]
                )
              }
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "add-group-btn",
                on: { click: _vm.addFilterGroup },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("add_circle_outline"),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("contactModuleRules.filterBuilder.addFilterGroup")
                    )
                  ),
                ]),
              ]
            ),
          ],
          2
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("filter_list_off")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }